import React from 'react'
// import { Alert, Error } from 'components/icons'
import styles from './FormError.module.sass'

interface Props {
  id: string
  message?: string | string[]
  variant?: '' | 'global'
  visible?: boolean
  className?: string
}

const FormError = (props: Props) => {
  const { id = '', message = '', variant = '', visible = false, className = '' } = props

  return visible && message ? (
    <div
      id={id}
      className={`${styles.root} ${variant ? styles[`root--${variant}`] : ''} ${className}`}
    >
      {message as string}
    </div>
  ) : (
    <></>
  )
}

export default FormError
